import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { useAddEmailQueueWatcher } from 'mutation/mail';
import UserSelector from 'components/ui/UserSelector';
import { useGetEmailQueueWatcher } from 'query/mail';
import { showErrorNotification } from 'services/common';

export default function AddEmailQueueWatcherButton() {
  const [visible, setVisible] = useState(false);
  const [user, setUser] = useState(null);
  const { data = [] } = useGetEmailQueueWatcher();
  const { isLoading, mutateAsync } = useAddEmailQueueWatcher();
  return (
    <>
      <Button icon={'plus'} onClick={() => setVisible(true)}>
        Add Email Queue Watcher
      </Button>
      <Modal
        okButtonProps={{
          disabled: !user,
          loading: isLoading,
          onClick: () => {
            mutateAsync(user.id)
              .then(() => {
                setVisible(false);
                setUser(null);
              })
              .catch(() => {});
          },
        }}
        title="Add Email Queue Watcher"
        visible={visible}
        onCancel={() => setVisible(false)}
      >
        <UserSelector
          user={user}
          onSelectUser={selectedUser => {
            const isUserSelected = data.find(
              watcher => watcher.user.id === selectedUser.id,
            );
            if (isUserSelected) {
              showErrorNotification(
                'User is already in the watcher list. Please select another user',
              );
            } else {
              setUser(selectedUser);
            }
          }}
        />
      </Modal>
    </>
  );
}
